import { render } from "./ProjectsComponent.vue?vue&type=template&id=9efd7ea6"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__